export const StudyMetadataPackageFilesConstant = [
    'Protocol',
    'CSR (may be redacted)',
    'Statistical Analysis Plan',
    'Data Dictionary',
    'Annotated Case Report Form',
    'Publication',
    'Other',
    'Unknown',
];
